// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Availability .Filters {
  position: relative;
  z-index: 100;
  border-radius: 8px 8px 0 0;
  border-bottom: none;
}
.Availability .VirtualTable-Container .VirtualTable .VirtualTable-Row {
  border-bottom: 1px solid var(--bs-gray-300);
}
.Availability .VirtualTable-Container .VirtualTable .VirtualTable-Row .VirtualTable-Cell {
  height: 6.5rem;
  padding: 0;
  border: none;
}
.Availability .VirtualTable-Container .VirtualTable .VirtualTable-Row .VirtualTable-Cell .AvailabilityTable-Cell {
  display: flex;
  justify-content: center;
}
.Availability .VirtualTable-Container .VirtualTable .VirtualTable-Row .VirtualTable-Cell.VirtualTable-HeaderCell > span {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Availability .VirtualTable-Container .VirtualTable .VirtualTable-Row .VirtualTable-Cell.VirtualTable-HeaderCell > span .AvailabilityTable-Header {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}
.Availability .VirtualTable-Container .VirtualTable .VirtualTable-Row .VirtualTable-Cell.VirtualTable-HeaderCell > span .AvailabilityTable-Header > div {
  position: absolute;
  z-index: 100;
  top: 2rem;
  right: 1rem;
}
.Availability .VirtualTable-Container .VirtualTable .VirtualTable-Row .VirtualTable-Cell.VirtualTable-HeaderCell > span .AvailabilityTable-Header > div > .fa-sort {
  opacity: 0.15;
}
.Availability .VirtualTable-Container .VirtualTable > *:not(.VirtualTable-Header) .VirtualTable-Row .VirtualTable-Cell + .VirtualTable-Cell {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Availability/styles.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;AAAJ;AAKM;EACE,2CAAA;AAHR;AAIQ;EACE,cAAA;EACA,UAAA;EACA,YAAA;AAFV;AAGU;EACE,aAAA;EACA,uBAAA;AADZ;AAGU;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADZ;AAEY;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAAd;AACc;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAChB;AAAgB;EACE,aAAA;AAElB;AAOU;EACE,YAAA;AALZ","sourcesContent":[".Availability {\n  .Filters {\n    position: relative;\n    z-index: 100;\n    border-radius: 8px 8px 0 0;\n    border-bottom: none;\n  }\n\n  .VirtualTable-Container {\n    .VirtualTable {\n      .VirtualTable-Row {\n        border-bottom: 1px solid var(--bs-gray-300);\n        .VirtualTable-Cell {\n          height: 6.5rem;\n          padding: 0;\n          border: none;\n          .AvailabilityTable-Cell {\n            display: flex;\n            justify-content: center;\n          }\n          &.VirtualTable-HeaderCell > span {\n            height: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            .AvailabilityTable-Header {\n              height: 100%;\n              display: flex;\n              flex-direction: column;\n              justify-content: center;\n              cursor: pointer;\n              > div {\n                position: absolute;\n                z-index: 100;\n                top: 2rem;\n                right: 1rem;\n                > .fa-sort {\n                  opacity: 0.15;\n                }\n              }\n            }\n          }\n        }\n      }\n      > *:not(.VirtualTable-Header) {\n        .VirtualTable-Row {\n          .VirtualTable-Cell + .VirtualTable-Cell {\n            border: none;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
